__turbopack_context__.v({
  "buttonActive": "Pagination-module__MbvPLq__buttonActive",
  "container": "Pagination-module__MbvPLq__container",
  "ellipsis": "Pagination-module__MbvPLq__ellipsis",
  "filterButton": "Pagination-module__MbvPLq__filterButton",
});
